export default __webpack_public_path__ + "static/media/vedecky-ctyrboj-logo-black-cs.78113f1d.png";